import { render } from "./EnvironmentBadge.vue?vue&type=template&id=2b9d4a0a&scoped=true"
import script from "./EnvironmentBadge.vue?vue&type=script&lang=js"
export * from "./EnvironmentBadge.vue?vue&type=script&lang=js"

import "./EnvironmentBadge.vue?vue&type=style&index=0&id=2b9d4a0a&scoped=true&lang=css"

import exportComponent from "/home/cpaps/dev-sistema-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9d4a0a"]])

export default __exports__